exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-336977cc]{grid-area:CI;background:var(--primary);display:flex;align-items:center;padding:0 17px;box-shadow:0 1px 0 0 rgba(0,0,0,.9);z-index:2}.title[data-v-336977cc]{color:var(--white);font-size:16px;margin-left:9px;font-weight:700}.description[data-v-336977cc]{color:var(--grey);font-size:15px}.separator[data-v-336977cc]{background:var(--white);height:24px;width:1px;opacity:.2;margin:0 13px}.icon[data-v-336977cc]{color:var(--symbol)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-336977cc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Channel-Info/index.vue
// module id = 78
// module chunks = 0